import { render } from "./ListePointVente.vue?vue&type=template&id=e4a0e3bc&ts=true"
import script from "./ListePointVente.vue?vue&type=script&lang=ts"
export * from "./ListePointVente.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__